import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { TravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TravelReimbursementGridWidgetService } from 'common/widget/travel-reimbursement/travel-grid.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class TravelReimbursementGridResolver extends GridResolver<TravelReimbursementModel, TravelReimbursementListingModel> {
    constructor(
        protected fs: TravelReimbursementGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}